/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServizioMensaAnagraficheListFilter { 
    nominativo?: string;
    email?: string;
    codice_fiscale?: string;
    include_non_accettate?: boolean;
    scuola_id?: string;
    classe?: string;
    sezione?: string;
}

